<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" >
  <div>
    {{"request_return" | translate}}: <strong>{{ data?.orderId }}</strong>
  </div>
</div>

<mat-divider class="-mx-6 text-border"></mat-divider>

<mat-dialog-content >
  <div class="flex flex-col" [formGroup]="form">
    <div *ngIf="data?.items?.length > 0 " class="w-full">
        <div class="my-2">{{'select_return_items' | translate}}</div>
    <div *ngFor="let control of itemsForm?.controls; let index = index;" class="flexx flexx-col">
        <div [formGroup]="control" class="flex flex-row item-cardd items-center">
            <mat-checkbox class="m-2" (change)="toggleItem($event, control)" formControlName="return"></mat-checkbox>
            <div style="width: 430px; text-overflow: ellipsis;">{{translateHelper.localize(data?.items[index]?.product?.name)}}</div>
            <mat-form-field appearance="outline" class="mt-1 flex-auto">
                <mat-label>{{"reason" | translate}}</mat-label>
                <mat-select formControlName="reason" required #reasonSelect (selectionChange)="onChange($event, control)">
                <mat-option *ngFor="let reason of reasons" [value]="translateHelper.localize(reason)" >{{translateHelper.localize(reason)}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="mt-1 mx-1 flex-auto" *ngIf="control.get('other')?.enabled">
                <mat-label>{{"other_reason" | translate}}</mat-label>
                <input type="text" formControlName="other" matInput required/>
            </mat-form-field>

            <mat-form-field appearance="outline" class="mt-1 mx-1 flex-auto">
                <mat-label>{{"amount" | translate}}</mat-label>
                <input  type="number" (keyup)="validateAmount(data?.items[index].amount,control)" (blur)="validateAmount(data?.items[index].amount,control)" min="1" [max]="data?.items[index].amount" formControlName="amount" matInput />
            </mat-form-field>

            <mat-form-field appearance="outline" class="mt-1 mx-1 flex-auto">
                <mat-label>{{"note" | translate}}</mat-label>
                <textarea formControlName="note" matInput rows="1"></textarea>
            </mat-form-field>
        </div>
        </div>
    </div>

    <mat-divider style="border: 1px solid rgba(128, 128, 128, 0.719); margin: 4px;"></mat-divider>
    <!--<div> {{""}} </div>
     <mat-form-field appearance="outline" class="mt-1 flex-auto">
      <mat-label>{{"reason" | translate}}</mat-label>
      <mat-select formControlName="reason" required #reasonSelect (selectionChange)="onChange($event, form)">
        <mat-option *ngFor="let reason of reasons" [value]="translateHelper.localize(reason)" >{{translateHelper.localize(reason)}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mt-1 flex-auto" *ngIf="form?.get('other').enabled">
      <mat-label>{{"other_reason" | translate}}</mat-label>
      <input type="text" formControlName="other" matInput required/>
    </mat-form-field> -->

    <mat-form-field appearance="outline" class="mt-1 flex-auto">
      <mat-label>{{"note" | translate}}</mat-label>
      <textarea formControlName="note" matInput ></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button button color="primary" mat-raised-button type="button" (click)="submit()">{{"Submit" | translate}}</button>
</mat-dialog-actions>
